import { useTranslation } from 'react-i18next';
import Collapsible from '@/components/Collapsible';
import faqTransactionIcon from '@/assets/faq_transaction.svg';
import faqAuthenticityIcon from '@/assets/faq_authenticity.svg';
import faqCompensationIcon from '@/assets/faq_compensation.svg';
import faqGuidelineIcon from '@/assets/faq_guideline.svg';

const FaqSection = () => {
  const { t } = useTranslation();

  const faqs = t('faq.questions', { returnObjects: true });

  const faqIcons = [
    faqTransactionIcon,
    faqAuthenticityIcon,
    faqCompensationIcon,
    faqGuidelineIcon
  ];

  // Function to render answer text with clickable links
  const renderAnswerWithLinks = (answer) => {
    // Define the guideline links
    const guidelineLinks = {
      'シングルカードのクオリティガイドライン': '/terms/quality_guideline_unopened_card',
      'ボックスのクオリティガイドライン': '/terms/quality_guideline_box',
      'Single Card Quality Guidelines': '/terms/quality_guideline_unopened_card',
      'Box Quality Guidelines': '/terms/quality_guideline_box'
    };

    // Split the answer by newlines to handle each line
    const lines = answer.split('\n');

    return lines.map((line, lineIndex) => {
      // Check if this line contains any of the guideline links
      const linkEntry = Object.entries(guidelineLinks).find(([linkText]) =>
        line.includes(linkText)
      );

      if (linkEntry) {
        const [linkText, linkUrl] = linkEntry;
        const parts = line.split(linkText);

        return (
          <span key={lineIndex}>
            {parts[0]}
            <a
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline cursor-pointer"
              onClick={(e) => e.stopPropagation()}
            >
              {linkText}
            </a>
            {parts[1]}
            {lineIndex < lines.length - 1 && <br />}
          </span>
        );
      }

      return (
        <span key={lineIndex}>
          {line}
          {lineIndex < lines.length - 1 && <br />}
        </span>
      );
    });
  };

  return (
    <div className=''>
      {faqs.map((faq, index) => (
        <Collapsible
          key={index}
          variant="faq"
          title={faq.question}
          icon={faqIcons[index]}
        >
          <div className="ml-9 text-[#aaaaaa] text-sm">
            {renderAnswerWithLinks(faq.answer)}
          </div>
        </Collapsible>
      ))}

      {/* Last item border */}
      <div className="border-t border-[#eeeeee]" />
    </div>
  );
};

export default FaqSection; 